import React, { useEffect } from "react";
import { StyleSheet, View, ImageBackground, TouchableOpacity, Image, type ViewStyle } from "react-native";
import I18n from "../../i18nSets/i18n";
import { birkenstockBackground, Icons } from "../../assets";
import LayoutWrapper from "../../components/LayoutWrapper/LayoutWrapper";
import { Styles } from "../../styles";
import { useGlobalState } from "../../shared/state";
import { useNavigation } from "@react-navigation/native";

const LanguageSelectModal: React.FC = (): JSX.Element => {
  const navigation = useNavigation();
  const [language, setLanguage] = useGlobalState("language");
  const [currentScanner] = useGlobalState("currentScanner");

  // set default language based on scanner language
  useEffect(() => {
    if (currentScanner?.["scanner-language"]) {
      const scannerLang = currentScanner["scanner-language"];
      if (language) {
        setLanguage(language);
      } else {
        setLanguage(scannerLang);
      }
      I18n.locale = scannerLang;
    }
  }, [currentScanner, setLanguage]);

  const onSelectLanguage = (lang: "en" | "de") => {
    setLanguage(lang);
    I18n.locale = lang;
  };

  const getLanguageButtonStyle = (lang: string) => [
    styles.flagButton,
    language === lang && styles.selectedFlagButton,
  ];

  return (
    <ImageBackground source={birkenstockBackground} style={Styles.backgroundImage}>
      <LayoutWrapper showHeaderCloseButton={false} showBackButton={false} hideInfoButton={true} hideBackButton={true} isHomeScreen={true}>
        <View style={styles.container}>
          <View style={styles.subcontainer}>
            <View style={styles.flagsWrapper}>
              <TouchableOpacity onPress={() => onSelectLanguage("de")} style={getLanguageButtonStyle("de")}>
                <Image source={Icons.germanFlag} style={styles.flagImage} />
              </TouchableOpacity>

              <TouchableOpacity onPress={() => onSelectLanguage("en")} style={getLanguageButtonStyle("en")}>
                <Image source={Icons.uKFlag} style={styles.flagImage} />
              </TouchableOpacity>
            </View>

            <View style={styles.backButtonWrapper}>
              <TouchableOpacity onPress={() => navigation.goBack()} style={styles.backButton}>
                <Image source={Icons.backArrowFilledIcon} style={styles.iconContainer} />
              </TouchableOpacity>
            </View>
          </View>
        </View>
      </LayoutWrapper>
    </ImageBackground>
  );
};

export default LanguageSelectModal;

/** Same footprint as language flags: % height is of the row wrapper (40% of subcontainer). */
const squareControlSize: ViewStyle = {
  height: "62%",
  aspectRatio: 1,
  alignSelf: "center",
  alignItems: "center",
  justifyContent: "center",
  borderRadius: 10,
};

const styles = StyleSheet.create({
  container: {
    width: "50%",
    height: "80%",
    alignSelf: "center",
    justifyContent: "center",
  },
  subcontainer: {
    width: "50%",
    height: "50%",
    alignSelf: "center",
    justifyContent: "space-between",
    backgroundColor: "white",
    flexDirection: "column",
    padding: 20,
  },
  flagsWrapper: {
    width: "80%",
    height: "40%",
    flexDirection: "row",
    alignSelf: "center",
    justifyContent: "space-around",
  },
  flagButton: {
    ...squareControlSize,
    overflow: "hidden",
  },
  selectedFlagButton: {
    height: "72%",
  },
  flagImage: {
    width: "100%",
    height: "100%",
    resizeMode: "contain",
    borderRadius: 20,
  },
  backButtonWrapper: {
    width: "50%",
    height: "40%",
    flexDirection: "row",
    alignSelf: "center",
    justifyContent: "space-around",
  },
  backButton: {
    ...squareControlSize,
    backgroundColor: "#0e2288",
  },
  iconContainer: {
    height: "100%",
    width: "100%",
    resizeMode: "contain",
  },
});
